import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function NestingSwiper({ title, data }) {
    const { useState, useEffect } = useGlobal();
    const [active, setActive] = useState(0);

    const handlePrev = (e: any) => {
        e.stopPropagation();
        const newActive = active === 0 ? data?.length - 1 : active - 1;
        setActive(newActive);
        handleScroll(newActive);
    };
    const handleNext = (e: any) => {
        e.stopPropagation();
        const newActive = active === data?.length - 1 ? 0 : active + 1;
        setActive(newActive);
        handleScroll(newActive);
    };

    const handleScroll = (idx: number) => {
        const wrapper = document.querySelector('.swiper1-wrapper') as HTMLUIListElement;
        if (wrapper) {
            const { scrollWidth } = wrapper;
            wrapper.style.left = `${-idx * (scrollWidth / data?.length)}px`;
        }
    };

    return (
        <div className={`nesting-swiper ${css['nesting-swiper']}`}>
            <h2 className="dp3-title">{title}</h2>
            <div className="swiper1">
                {data?.length > 1 && (
                    <div className="swiper-button">
                        <span className="swiper-button-prev" onClick={handlePrev}></span>
                        <span className="swiper-button-next" onClick={handleNext}></span>
                    </div>
                )}
                <ul className="swiper-pagination">
                    {data?.map((pagination: any, k: number) => (
                        <li className={`swiper-pagination-bullet${active === k ? ' swiper-pagination-bullet-active' : ''}`} key={k}></li>
                    ))}
                </ul>
                <ul className="swiper1-wrapper">
                    {data?.map((item: any, k: number) => {
                        return (
                            <li className={`swiper-item`} key={k}>
                                <Swiper
                                    className="swiper2"
                                    modules={[Pagination]}
                                    pagination={
                                        item?.imgs?.length > 1
                                            ? {
                                                  clickable: true,
                                              }
                                            : false
                                    }
                                    loop={item?.imgs?.length > 1}
                                    spaceBetween={0}
                                    // centeredSlides={true}
                                    slidesPerView={'auto'}
                                    initialSlide={0}
                                >
                                    {item?.imgs?.map((list: any, m: number) => {
                                        return (
                                            <SwiperSlide className={`swiper-list`} key={`${k}_${m}`}>
                                                <div className="list-img">
                                                    {list?.img?.endsWith('.mp4') ? (
                                                        <video src={list.img} autoPlay loop width="100%" height="100%" playsInline preload="auto" />
                                                    ) : (
                                                        <EFPicture src={list?.img} alt={list?.title || item?.title} />
                                                    )}
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                                <div className="item-info">
                                    {item?.title && <p className="item-title">{item.title}</p>}
                                    {item.lMsTips && item.lMsTipsLink && (
                                        <a className="card-title-link" href={item.lMsTipsLink}>
                                            {item.lMsTips}
                                        </a>
                                    )}
                                    {item?.desc && <p className="item-desc">{item.desc}</p>}
                                    {item.rMsTips && <p className="card-rMsTips">{item.rMsTips}</p>}
                                    {item.rMsTips2 && <p className="card-rMsTips card-rMsTips-2">{item.rMsTips2}</p>}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
